// Module
var code = "<account-page> <account-page-body> <div ng-controller=\"AccountPasswordController as $ctrl\"> <password-change submit-button=\"{{ 'account.change-pass' | translate }}\" on-submit=\"$ctrl.confirmPasswordChange()\" on-cancel=\"$ctrl.cancelPasswordChange()\"></password-change> </div> </account-page-body> </account-page> ";
// Exports
export default code;